import { useFormContext } from "react-hook-form";

import { TableSelectAllCheckbox } from "@/components/Layout/Table/TableSelectAllCheckbox/TableSelectAllCheckbox";

import { ItemizedBillListIdForm } from "./ItemizedBillOverview";

/**
 * Adapts the itemized bill table's form shape to TableSelectAllCheckbox. This
 * form already stores the selection as the id array the shared component works
 * in — the ids being the encoded `serviceId|period` pairs — so there is nothing
 * to map, only to read and write.
 */
export const EvnSelectAllCheckbox = ({
  currentPageItemizedBillIds,
}: {
  currentPageItemizedBillIds: string[];
}) => {
  const { watch, setValue } = useFormContext<ItemizedBillListIdForm>();

  return (
    <TableSelectAllCheckbox
      dataTestid="evn-list-header-checkbox"
      currentPageIds={currentPageItemizedBillIds}
      selectedIds={watch("selectedItems") ?? []}
      onChange={(nextSelectedIds) => setValue("selectedItems", nextSelectedIds)}
    />
  );
};
